import EntityInputField from "vue-forms/components/EntityInputField";
import EntityFormField from "vue-forms/components/EntityFormField";
import service from "./ProviderService";

const ProviderInputField = {
  name: "provider-input-field",

  mixins: [EntityInputField],

  props: {
    service: {
      default: () => service
    }
  },

  methods: {
    customLabel(item) {
      return item.companyName;
    }
  }
};

export default {
  name: "provider-form-field",

  mixins: [EntityFormField],

  props: {
    component: {
      default: () => ProviderInputField
    }
  }
};
